<template>
  <div
    class="invitation"
    :class="{
      'invitation-mobile': h5,
    }"
  >
    <div class="header">
      <div>
        <Resource
          :src="
            getFeUrl(
              isChinese()
                ? '/youyan-platform/svg/invitation-list.svg'
                : '/youyan-platform/svg/invitation-list-us.svg',
            )
          "
          class="total-img"
          alt=""
          srcset=""
        />
        <div class="total-content">
          <span>{{ $t('zong-ji') }}:</span>
          <span class="total">{{ totalCount }}</span>
          <span>{{ $t('yan-bi') }}</span>
        </div>
      </div>
    </div>
    <a-spin :spinning="loading">
      <a-table
        v-if="list.length"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        class="invite-table"
        :scroll="{ y: 'calc(100vh - 275px)' }"
      >
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'sequence'">
            <div class="sequence">
              <Resource v-if="index <= 2" :src="imgList[index]" alt="" srcset="" />
              <div v-else class="dot">{{ index + 1 }}</div>
            </div>
          </template>
          <template v-if="column.key === 'name'">
            <div class="truncate">
              <a-avatar
                :size="h5 ? 20 : 40"
                :src="record?.accept_user_info?.logo_url"
                :class="h5 ? 'mr-[5px]' : 'mr-[8px]'"
              />
              <span class="user-name">
                {{ record?.accept_user_info?.name }}
              </span>
            </div>
          </template>
          <template v-else-if="column.key === 'current'">
            <div class="progress">
              <div class="progress-item gap" :class="{ complete: !!record?.reward?.register }">
                <div class="item-icon">1</div>
                <div class="item-title">{{ $t('zhu-ce') }}</div>
              </div>
              <div class="progress-item" :class="{ complete: !!record?.reward?.package }">
                <div class="item-icon">2</div>
                <div class="item-title">{{ $t('sheng-ji-tao-can') }}</div>
              </div>
            </div>
          </template>
          <template v-else-if="column.key === 'reward'">
            <div v-if="record?.reward" class="list">
              <div v-if="record?.reward?.register?.credit_coins" class="list-item">
                <span class="label">{{ $t('zhu-ce') }}</span>
                <span class="high"> +{{ record?.reward?.register?.credit_coins }} </span>
              </div>
              <div v-if="record?.reward?.package?.credit_coins" class="list-item">
                <span class="label">{{ record?.reward?.package?.name }}</span>
                <span class="high"> +{{ record?.reward?.package?.credit_coins }} </span>
              </div>
            </div>
            <div v-else class="text-font-80">--</div>
          </template>
        </template>
      </a-table>
      <div v-else class="min-h-[80vh] mt-[40px]">
        <EmptyView>
          <template #content>
            <div
              class="text-[16px] leading-[24px] text-font-80 mb-[20px] max-w-[278px] text-center"
            >
              {{
                $t(
                  'nin-huan-mei-you-yao-qing-cheng-gong-de-hao-you-kuai-lai-huo-qu-xia-fang-lian-jie-zhuan-fa-yao-qing-hao-you-ling-qu-jiang-li-ba',
                )
              }}
            </div>
          </template>
        </EmptyView>
      </div>
    </a-spin>
  </div>
</template>
<script lang="ts" setup>
import { getRankList } from '~/api';
const { $t } = useNuxtApp();

const props = defineProps<{
  h5: boolean;
}>();

const columns = [
  {
    key: 'sequence',
    width: props.h5 ? 20 : 60,
  },
  {
    title: $t('hao-you'),
    key: 'name',
    width: props.h5 ? 110 : 'auto',
  },
  {
    title: $t('dang-qian-jie-duan'),
    key: 'current',
    width: props.h5 ? 84 : 'auto',
  },
  {
    title: $t('zhu-li-jiang-li'),
    key: 'reward',
  },
];
const imgList = [
  getFeUrl('/youyan-platform/png/icon-invite-1.png'),
  getFeUrl('/youyan-platform/png/icon-invite-2.png'),
  getFeUrl('/youyan-platform/png/icon-invite-3.png'),
];
const totalCount = ref(0);
const list = ref([]);
const loading = ref(false);

const handleGetRankList = async () => {
  loading.value = true;
  try {
    const response: any = await getRankList({
      many: true,
      page: 1,
      page_size: 1000,
    });
    loading.value = false;
    if (!response?.code) {
      totalCount.value = response?.data?.total_credit_coins;
      list.value = response.data?.results;
    }
  } catch (error) {
    console.warn('[Pull New] handleGetRankList error', error);

    loading.value = false;
  }
};

onMounted(() => {
  handleGetRankList();
});
</script>
<style lang="scss" scoped>
.invitation {
  @apply bg-back-bg absolute top-[50px] left-[200px] right-[200px];
  border-radius: 28px 28px 0px 0px;
  min-height: calc(100% - 50px);
  .header {
    @apply w-full flex justify-center items-center mt-[50px];

    .total-content {
      @apply text-[#FF9E00] text-[20px] leading-[27px] font-bold text-center mt-[24px] mb-[20px];

      .total {
        @apply text-[36px] mx-[10px];
      }
    }
  }

  .invite-table {
    :deep(.ant-table) {
      background-color: var(--back-bg);
    }
    :deep(.ant-table-body) {
      padding-bottom: 140px;
    }
  }

  :deep(.ant-table-cell) {
    background-color: var(--back-bg);

    &::before {
      display: none;
    }
  }
  :deep(.ant-table-container) {
    &::after {
      display: none;
    }
  }

  .sequence {
    img {
      @apply w-[30px] -translate-y-[2px];
    }

    .dot {
      @apply w-[28px] h-[28px] bg-back-6 rounded-[50%] text-14 text-[#FFFFFF] font-medium text-center flex justify-center items-center;
    }
  }

  .progress {
    @apply flex flex-nowrap gap-x-[48px];

    .progress-item {
      @apply relative flex flex-nowrap gap-x-[6px];

      &.gap {
        &::after {
          @apply absolute w-[36px] h-[1px] bg-back-5 block top-1/2 -translate-y-1/2 ml-[6px];
          inset-inline-start: 100%;
          display: block;
          content: '';
        }
      }

      .item-icon {
        @apply bg-back-6 w-[18px] h-[18px] rounded-[50%] flex justify-center items-center text-center text-12 font-medium text-[#FFFFFF];
      }

      .item-title {
        @apply text-14 text-font-30 font-medium;
      }

      &.complete {
        .item-icon {
          @apply bg-success-6;
        }

        .item-title {
          @apply text-font-80;
        }
      }
    }
  }

  .list {
    @apply flex gap-x-[30px] flex-nowrap text-14 font-medium text-font-80;

    .list-item {
      @apply flex flex-nowrap;
      .label {
        @apply mr-[10px] whitespace-nowrap;
      }
      .high {
        @apply text-[#FF8200] font-semibold;
      }
    }
  }
}
.invitation-mobile {
  width: 366px;
  left: 50%;
  padding: 0 9px;
  transform: translateX(-50%);
  top: 186px;
  height: calc(100% - 186px);
  :deep(.ant-empty .ant-empty-image img) {
    margin: 0 auto;
  }
  :deep(.ant-table-cell) {
    font-size: 12px;
  }
  .header {
    margin-top: 30px;
    .total-img {
      width: 133px;
      margin: 0 auto;
    }
    .total-content {
      font-size: 12px;
      margin-top: 8px;
      margin-bottom: 2px;
      .total {
        font-size: 18px;
        margin: 0 5px;
      }
    }
  }
  .sequence {
    img {
      width: 16px;
    }
    .dot {
      width: 16px;
      height: 16px;
      font-size: 10px;
    }
  }
  .invite-table {
    :deep(.ant-table-thead th) {
      padding: 12px 20px 12px 0px !important;
    }
    :deep(.ant-table-tbody .ant-table-row td) {
      padding: 12px 20px 12px 0px !important;
    }
  }
  .progress {
    display: block;
    .progress-item {
      align-items: center;
      .item-icon {
        height: 12px;
        width: 12px;
        font-size: 8px;
      }
      .item-title {
        font-size: 10px;
      }
      &.gap {
        &::after {
          width: 15px;
          margin-left: 0;
          left: 43px;
        }
      }
    }
  }
  .list {
    display: block;
    font-size: 10px;
    .list-item {
      .label {
        margin-right: 4px;
      }
    }
  }
  .user-name {
    font-size: 10px;
    color: #000000;
  }
}
</style>
